const colors = {
  primary: '#00cccc',
  text: '#FFF',
  secoundry: '#ffcc99',
}

export default colors
